// extracted by mini-css-extract-plugin
module.exports = {"trial":"Trial_trial___LXnl","special":"Trial_special__OUeR7","expiration":"Trial_expiration__g2JKx","text":"Trial_text___8uKr"};